:host {
  .hide {
    display: none !important;
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
  }

  .full-height {
    height: 100%;
  }

  .chat {
    position: relative;
    height: 100%;

    .chat-header {
      position: relative;
      height: 60px;
      display: flex;
      justify-content: center;
      padding: 10px 25px 0;
      background: #ffffff;
      background: var(--bg-primary);
      align-items: center;

      &--separator {
        background: #f5f5f5;
        background: var(--bg-primary);
        position: absolute;
        width: 750px;
        height: 50px;
        left: -75px;
        border-radius: 0 0 50% 50%;
        bottom: -10px;
        z-index: 1;
        box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.04);
      }
      &--separator--cache {
        background: white;
        width: 100%;
        position: absolute;
        height: 50px;
        bottom: 0;
        z-index: 2;
      }

      &__user {
        position: relative;
        z-index: 3;

        img {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }

        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #0098ff;
          text-decoration: none;
          font-size: 12px;
        }
      }

      &__close {
        padding: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 20px;
        z-index: 10;

        img {
          width: 16px;
          height: 16px;
          object-fit: contain;
          filter: invert(19%) sepia(16%) saturate(0%) hue-rotate(157deg) brightness(94%)
            contrast(95%);
          filter: var(--icon-font-primary);
        }
      }
    }

    .chat-messages {
      overflow: auto;
      height: calc(100% - 75px);
      box-sizing: border-box;
      width: calc(100% + 30px);
      left: -15px;
      padding: 0 15px;
      position: relative;
      padding-top: 20px;

      &.chat-messages--no-input {
        height: 100%;
      }

      &.chat-messages--full {
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    .chat-input {
      position: relative;
      padding: 20px 0 0;
      box-sizing: border-box;
      height: 90px;

      textarea {
        border: none;
        font-size: 16px;
        width: 100%;
        font-family: Roboto, sans-serif;
        padding: 10px 40px 10px 20px;
        box-sizing: border-box;
        height: 50px;
        border-radius: 8px 10px 10px 8px;
        overflow: hidden;
        line-height: 30px;
        color: #666666;
        color: var(--font-secondary);
        background: #ffffff;
        background: var(--bg-primary);
        resize: none;

        &:focus {
          outline: none;
        }
      }

      &__actions {
        cursor: pointer;
        background: var(--blue);
        background: #0098ff;
        padding: 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 30px;

        img {
          filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
            contrast(105%);
          filter: var(--icon-white);
          cursor: pointer;
        }

        &.disabled {
          cursor: not-allowed;
          background: rgba(0, 0, 0, 0.12);
          background: var(--bg-disabled-button);

          img {
            cursor: not-allowed;
            filter: invert(73%) sepia(0%) saturate(68%) hue-rotate(243deg) brightness(97%)
              contrast(86%);
            filter: var(--icon-font-disabled);
          }
        }
      }
    }

    .chat-input-menu {
      position: absolute;
      bottom: 0px;
      left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      z-index: 1;

      img {
        cursor: pointer;
        width: 15px;
        height: 15px;
        object-fit: contain;
        filter: invert(19%) sepia(16%) saturate(0%) hue-rotate(157deg) brightness(94%) contrast(95%);
        filter: var(--icon-font-primary);
        margin-right: 10px;
      }

      &__menu {
        display: flex;
        position: absolute;
        left: -10px;
        top: -35px;
        padding: 15px;
        white-space: nowrap;
        border-radius: 10px;
        background-color: #ffffff;
        background-color: var(--bg-primary);
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
        box-sizing: border-box;
        align-items: center;

        div {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        img {
          width: 20px;
          object-fit: contain;
          filter: invert(66%) sepia(83%) saturate(2738%) hue-rotate(315deg) brightness(115%)
            contrast(92%);
          filter: var(--icon-salmon);
        }

        &.debug {
          top: -65px;
        }
        .load {
          margin: 0 auto;
        }

        .menu {
          display: flex;
          flex-direction: column;
          color: #666666;
          color: var(--font-secondary);

          div {
            width: 100%;
          }

          div:first-child {
            margin-bottom: 10px;

            img {
              filter: inherit;
            }
          }
        }
      }
    }
  }
}
